import React from 'react';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import SponsoredCohortGroupMembers from '../components/SponsoredCohortGroupMembers';

export default function CohortGroupMembers() {
  return (
    <AnalyticsPageLayout
      title="Cohort Group Members"
      description="Group membership lists for each cohort."
    >
      <SponsoredCohortGroupMembers />
    </AnalyticsPageLayout>
  );
}
